import TemplateView from '../../../../TemplateView'
import Day from './Day'
import {dayStatuses} from '../../constants'
import {DayIteratorWithWorkSchedule, getMonthNameKey, isSameMonth} from '../../utils'
import MonthHeaderDay from './MonthHeaderDay'
import SimpleDiv from '../../../../components/SimpleDiv'

export default class Month extends TemplateView {
    constructor({
        additionalClass = '',
        firstMonthDate = null,
        currentDate = new Date(),
        weekStartDay = 1, // can take values starting from 1 (sunday) to 7 (saturday) in order to comply with java.util.Calendar class
        defaultWorkSchedules = [],
        editable = false,
        onDayClick = () => {},
    } = {}) {
        super()

        this.params = {
            additionalClass,
            firstMonthDate,
            currentDate,
            weekStartDay: weekStartDay - 1,
            defaultWorkSchedules,
            editable,
        }

        this.callbacks = {
            onDayClick,
        }

        this.state = {
            corporateDays: {},
        }

        this.days = {}

        this.onStatePropertyChanged('corporateDays', (corporateDays) => {
            for (let date in corporateDays) {
                let status = dayStatuses.STANDARD_DAY
                if (corporateDays[date].working)
                    status = dayStatuses.NON_STANDARD_WORKING_DAY
                else
                    status = dayStatuses.CORPORATE_HOLIDAY

                this.days[date].setState({
                    status,
                    title: corporateDays[date].name,
                })
            }
        })
    }

    templateHtml() {
        return "<div class='components_month <%-additionalClass%>'>" +
               "    <div class='monthName'><%=monthName%></div>" +
               "    <div class='monthDaysHeader'></div>" +
               "    <div class='monthDays'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }

    messageKeys() {
        return {
            monthName: getMonthNameKey(this.params.firstMonthDate.getMonth()),
        }
    }

    afterRender() {
        this.$monthDaysHeader = this.find('.monthDaysHeader')
        this.$monthDays = this.find('.monthDays')

        for (let n = 0; n < 7; n++) {
            new MonthHeaderDay({
                dayNum: (this.params.weekStartDay + n) % 7,
            }).init(this.$monthDaysHeader)
        }

        //add empty date cells
        for (let n = 0; n < (7 + this.params.firstMonthDate.getFirstDayOfMonth() - this.params.weekStartDay) % 7; n++) {
            new SimpleDiv({
                additionalClass: 'components_day monthEmptyDay',
            }).init(this.$monthDays)
        }

        let currentDay
        for (let i = new DayIteratorWithWorkSchedule(this.params.firstMonthDate, this.params.firstMonthDate.getLastDateOfMonth(),
            this.params.defaultWorkSchedules); i.hasNext();) {
            currentDay = i.next()
            this.days[currentDay.date.getDate()] = new Day({
                additionalClass: 'monthDay',
                editable: this.params.editable,
                onClick: this.callbacks.onDayClick,
                ...currentDay,
            }).init(this.$monthDays)
        }

        const currentMonth = isSameMonth(this.params.firstMonthDate, this.params.currentDate)
        this.$el.toggleClass('current', currentMonth)
        if (currentMonth) {
            this.days[this.params.currentDate.getDate()].setState({
                current: true,
            })
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/month/Month.js